<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 20 20"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <path d="M8.20857 20H11.7914V0H8.20857V20Z"></path>
        <path d="M0 11.7914H20V8.20857H0V11.7914Z"></path>
    </svg>
</template>

<script>
export default {
    name: 'AddSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
